const API = "https://jm.komerzy.com/backend/?url=clientesapi";

/* =========================
   LISTAR CLIENTES
========================= */
export const getClientes = async () => {

    try {

        const res = await fetch(`${API}&action=listar`);

        const json = await res.json();

        return json.data;

    } catch (error) {

        console.error("Error al obtener clientes:", error);

        return [];
    }
};

/* =========================
   GUARDAR CLIENTE
========================= */
export const guardarCliente = async (cliente) => {

    try {

        const res = await fetch(`${API}&action=registrarCliente`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(cliente),
        });

        const json = await res.json();

        if (!res.ok) {

            console.error("Error backend:", json);

            return {
                status: "error",
                message: json?.message || "Error al guardar cliente"
            };
        }

        return json;

    } catch (error) {

        console.error("Error en guardarCliente:", error);

        return {
            status: "error",
            message: "Error de conexión con el servidor"
        };
    }
};

/* =========================
   ACTUALIZAR CLIENTE
========================= */
export const actualizarCliente = async (cliente) => {

    try {

        const res = await fetch(`${API}&action=actualizarCliente`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(cliente),
        });

        const json = await res.json();

        if (!res.ok) {

            console.error("Error backend:", json);

            return {
                status: "error",
                message: json?.message || "Error al actualizar cliente"
            };
        }

        return json;

    } catch (error) {

        console.error("Error en actualizarCliente:", error);

        return {
            status: "error",
            message: "Error de conexión con el servidor"
        };
    }
};

/* =========================
   ELIMINAR CLIENTE
========================= */
export const eliminarCliente = async (cliente) => {

    try {

        const res = await fetch(`${API}&action=eliminarCliente`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(cliente),
        });

        const json = await res.json();

        if (!res.ok) {

            console.error("Error backend:", json);

            return {
                status: "error",
                message: json?.message || "Error al eliminar cliente"
            };
        }

        return json;

    } catch (error) {

        console.error("Error en eliminarCliente:", error);

        return {
            status: "error",
            message: "Error de conexión con el servidor"
        };
    }
};